// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"f9299782","313":"e7bf3577","322":"12e76364","326":"6e4213b4","422":"30caeedb","558":"70344434","654":"38397c21","671":"267c913d","837":"80bc3d2e"}[chunkId] + ".chunk.js";
};